import { defineMessages } from 'utils/intl';

export default defineMessages({
  addToCart: 'Dodaj do koszyka',
  quantityShortName: '{quantity} szt.',
  mainPhoto: 'Zdjęcie główne',
});
